import { SharedState } from '@trello/shared-state';

interface CardComposerSharedState {
  isOpen: boolean;
  idActiveList: string | null;
  listComposerIndex: number;
}

export const cardComposerSharedState = new SharedState<CardComposerSharedState>(
  {
    isOpen: false,
    idActiveList: null,
    listComposerIndex: 0,
  },
);
